<script lang="ts">
import "@cisco-u/link/cu-link.js";

import { defineComponent } from "vue";
import { mapGetters, mapMutations } from "vuex";

import AnchorTargetBlank from "@/components/AnchorTargetBlank.vue";
import AnchorTargetSelf from "@/components/AnchorTargetSelf.vue";
import { SERVICEDESK_PORTAL_URL } from "@/consts/externalUrls";
import { Statsig } from "@/env/statsig/client";

export default defineComponent({
  components: {
    AnchorTargetBlank,
    AnchorTargetSelf,
  },
  data() {
    return {
      surveyId: 0,
      adminUrl: globalThis.env.CISCO_ADMIN_URL,
      customerAdminUrl: globalThis.env.CUSTOMER_ADMIN_URL,
      productSSOTUrl: globalThis.env.PRODUCT_SSOT_URL,
      enableMyCertifications: false,
      SERVICEDESK_PORTAL_URL,
    };
  },
  async mounted() {
    this.enableMyCertifications = await Statsig.featureGate(
      "ENABLE_MY_CERTIFICATIONS"
    );
  },
  computed: {
    ...mapGetters({
      isAdminRole: "user/adminRole",
      isCustomerAdminRole: "user/customerAdminRole",
      isContentAdminRole: "user/contentAdminRole",
    }),
  },

  methods: {
    ...mapMutations({
      hideDropDown: "user/hideDropDown",
    }),

    clearStorage() {
      localStorage.clear();
      globalThis.location.href = "/sso-logout";
    },
  },
});
</script>

<template>
  <div
    data-cy="drop-down-wrapper"
    id="dropdown"
    class="absolute top-10 right-[3.25rem] z-[1200] mt-24 w-[15.25rem] rounded-xl bg-white-lightest text-left text-16 text-black-dark shadow-xl dark:bg-black-dark dark:text-white-dark md:right-[3.75rem] xlg:right-[4.25rem]"
    v-click-outside="hideDropDown"
    @click="hideDropDown"
    @keyup.enter="hideDropDown"
    @keyup.space="hideDropDown"
  >
    <div class="flex cursor-pointer flex-col text-left focus:outline-black">
      <router-link
        tabindex="0"
        data-cy="my-dashboard"
        :to="{ name: 'dashboard' }"
        class="border-b px-6 py-4 text-22 font-slight hover:rounded-t-lg hover:bg-blue-light hover:text-white-lightest"
        >My Dashboard</router-link
      >
      <router-link
        tabindex="0"
        data-cy="my-list"
        :to="{ name: 'my-list' }"
        class="px-6 py-2 font-slight hover:bg-blue-light hover:text-white-lightest"
        >My Learning</router-link
      >
      <router-link
        v-if="enableMyCertifications"
        tabindex="0"
        data-cy="my-certifications"
        :to="{ name: 'my-certifications' }"
        class="px-6 py-2 font-slight hover:bg-blue-light hover:text-white-lightest"
        >My Certifications</router-link
      >
      <router-link
        tabindex="0"
        data-cy=""
        :to="{ name: 'community' }"
        class="px-6 py-2 font-slight hover:bg-blue-light hover:text-white-lightest"
        >My Communities</router-link
      >
      <router-link
        tabindex="0"
        data-cy="my-account"
        :to="{ name: 'my-account' }"
        class="px-6 py-2 font-slight hover:bg-blue-light hover:text-white-lightest"
        >My Account</router-link
      >
      <anchor-target-self
        v-if="isCustomerAdminRole"
        data-cy="customer-admin"
        :url="customerAdminUrl"
        :noUnderline="true"
        color="black"
        class="border-b border-t px-6 pb-2 pt-2 text-22 font-slight hover:bg-blue-light hover:text-white-lightest"
      >
        Customer Admin
      </anchor-target-self>

      <anchor-target-self
        v-if="isCustomerAdminRole"
        tabindex="0"
        data-cy="customer-subscriptions"
        :url="customerAdminUrl + '/subscriptions'"
        rel="noopener"
        class="px-6 py-2 font-slight hover:bg-blue-light hover:text-white-lightest"
        color="black"
        :noUnderline="true"
      >
        Orders
      </anchor-target-self>
      <anchor-target-self
        v-if="isCustomerAdminRole"
        data-cy="customer-learners"
        :url="customerAdminUrl + '/learners'"
        class="px-6 py-2 font-slight hover:bg-blue-light hover:text-white-lightest"
        color="black"
        :noUnderline="true"
      >
        Learners
      </anchor-target-self>
      <anchor-target-blank
        v-if="isContentAdminRole"
        data-cy="content-admin"
        :url="productSSOTUrl"
        :noUnderline="true"
        color="black"
        class="flex items-center border-t px-6 py-2 text-22 font-slight hover:bg-blue-light hover:text-white-lightest"
      >
        Catalog Management
      </anchor-target-blank>
      <anchor-target-blank
        data-cy="help-support"
        :url="SERVICEDESK_PORTAL_URL"
        :noUnderline="true"
        color="black"
        class="flex items-center border-t px-6 py-2 text-22 font-slight hover:bg-blue-light hover:text-white-lightest"
      >
        Help & Support
      </anchor-target-blank>
      <anchor-target-blank
        v-if="isAdminRole"
        data-cy="admin"
        :url="adminUrl"
        :noUnderline="true"
        color="black"
        class="border-t px-6 pb-2 pt-2 text-22 font-slight hover:bg-blue-light hover:text-white-lightest"
      >
        Admin
      </anchor-target-blank>
      <div
        class="group border-t px-6 pb-2 pt-2 text-22 hover:rounded-b-lg hover:bg-blue-light hover:text-white-lightest focus:outline-black"
      >
        <cu-link
          class="flex items-center font-slight"
          data-cy="logout"
          @click.prevent="clearStorage"
          @keyup.enter="clearStorage"
          @keyup.space="clearStorage"
          href="/sso-logout"
          noUnderline="true"
          color="black"
        >
          Sign Out
        </cu-link>
      </div>
    </div>
  </div>
</template>
